import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        background: "linear-gradient(135deg, #000, #1a1a1a)",
        color: "#FFD700",
        overflow: "hidden",
        position: "relative",
        padding: "0 20px",
      }}
    >

      {/* Animated 404 */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        style={{ zIndex: 2 }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "7rem", md: "10rem" },
            fontWeight: 800,
            letterSpacing: "5px",
            textShadow: "0 0 30px rgba(255,215,0,0.6)",
          }}
        >
          404
        </Typography>
      </motion.div>

      {/* Text Animation */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.8 }}
        style={{ zIndex: 2 }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 2,
            color: "#fff",
            fontWeight: 500,
            letterSpacing: "1px",
          }}
        >
          Oops! The page you’re looking for doesn’t exist.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: "#ccc",
            maxWidth: "500px",
            mx: "auto",
          }}
        >
          It seems you’ve wandered off the divine path. Let’s guide you back to
          the home page.
        </Typography>

        <Button
          component={Link}
          to="/"
          sx={{
            background:
              "linear-gradient(135deg, #FFD700, #c9a600)",
            color: "#000",
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: "30px",
            boxShadow: "0 0 20px rgba(255,215,0,0.5)",
            transition: "all 0.3s ease",
            "&:hover": {
              background:
                "linear-gradient(135deg, #fff3cd, #FFD700)",
              boxShadow: "0 0 25px rgba(255,215,0,0.8)",
              transform: "scale(1.05)",
            },
          }}
        >
          Back to Home
        </Button>
      </motion.div>
    </Box>
  );
};

export default NotFound;
